var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaymentFraudSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12105_26792)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12105_26792)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.612 5.65462V2.73796C12.612 2.09362 12.0896 1.57129 11.4453 1.57129H2.11198C1.46765 1.57129 0.945312 2.09362 0.945312 2.73796V8.57129C0.945312 9.21562 1.46765 9.73796 2.11198 9.73796H6.77865M12.2941 9.76204V8.59538C12.2941 7.95104 11.7722 7.42871 11.1284 7.42871C10.4845 7.42871 9.96263 7.95104 9.96263 8.59538V9.76204M12.2941 9.76204H12.3941C12.7672 9.76204 12.9537 9.76204 13.0962 9.83471C13.2215 9.89864 13.3234 10.0006 13.3873 10.126C13.4599 10.2686 13.4599 10.4553 13.4599 10.8287V11.362C13.4599 11.7354 13.4599 11.9221 13.3873 12.0647C13.3234 12.1902 13.2215 12.2921 13.0962 12.356C12.9537 12.4287 12.7672 12.4287 12.394 12.4287H9.86271C9.4896 12.4287 9.30308 12.4287 9.16059 12.356C9.03522 12.2921 8.93337 12.1902 8.86948 12.0647C8.79688 11.9221 8.79688 11.7354 8.79688 11.362V10.8287C8.79688 10.4553 8.79688 10.2686 8.86948 10.126C8.93337 10.0006 9.03522 9.89864 9.16059 9.83471C9.30308 9.76204 9.4896 9.76204 9.86271 9.76204H9.96263M12.2941 9.76204H9.96263",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12105_26792)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.921875 4.47461H12.5885",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12105_26792",
  x: 0.445312,
  y: 1.07129,
  width: 14.5156,
  height: 12.8574,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12105_26792"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12105_26792",
  x: 0.421875,
  y: 3.97461,
  width: 13.6641,
  height: 2,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12105_26792"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12105_26792"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(0.203125)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentFraudSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";